import React from 'react';
import { Button } from './ui/Button';
import { Calendar, MapPin } from 'lucide-react';
export function EventSection() {
  return <section id="event" className="py-24 bg-[#ecdfd2]/20" data-id="element-24" data-mp="3kgj6z6plwgw3">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25" data-mp="36ikwwdibj6me">
        <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-20" data-id="element-26" data-mp="36k5qo0wt6lj7">
          {/* Circular Image */}
          <div className="flex-1 w-full flex justify-center order-2 md:order-1" data-id="element-27" data-mp="2ws8eaqu2dniw">
            <div className="relative" data-id="element-28" data-mp="2wq5gvlql0s45">
              <div className="absolute inset-0 rounded-full bg-[#d4956a]/20 blur-2xl scale-110" data-id="element-29" data-mp="31ji53urcmwwd"></div>
              <div className="relative w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden shadow-2xl ring-4 ring-white" data-id="element-30" data-mp="2ns3gn8eoa3hx">
                <img src="https://cdn.magicpatterns.com/uploads/s18Tp6VvAWgddtmmdJSLUq/Downtown-Harrisonburg-VA-.jpg" alt="Downtown Harrisonburg" className="w-full h-full object-cover" data-id="element-31" data-mp="2rtyjwig5yqyc" />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 text-center md:text-left order-1 md:order-2" data-id="element-32" data-mp="xdkzos7gsw6w">
            <p className="text-xs font-semibold text-[#d4956a] uppercase tracking-wider mb-3" data-id="element-33" data-mp="scdsovd5c11a">
              Until next year
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-[#3b2316] mb-6" data-id="element-34" data-mp="11dlewf2e1bf0">
              See You in 2027
            </h2>

            <p className="text-xl text-[#5a3a28]/80 leading-relaxed mb-8" data-id="element-35" data-mp="dososz8g5xsb">
              In partnership with Harrisonburg Downtown Renaissance, we honored
              Harrisonburg and Rockingham County fathers and father-figures
              during the Best Weekend Ever. Essay submissions for next year's
              celebration will open with our school partners in the spring.
            </p>

            <div className="flex flex-col gap-4 mb-8 items-center md:items-start" data-id="element-36" data-mp="3r1m371ph55pe">
              <div className="flex items-center gap-3 text-lg text-[#3b2316] font-medium" data-id="element-37" data-mp="3m4cghttgz859">
                <Calendar className="w-6 h-6 text-[#c06a2b]" data-id="element-38" data-mp="1q0xzust52oql" />
                <span data-id="element-39" data-mp="1pyboei34np33">Returning June 2027</span>
              </div>
              <div className="flex items-center gap-3 text-lg text-[#3b2316] font-medium" data-id="element-40" data-mp="1uy7tylrh3okr">
                <MapPin className="w-6 h-6 text-[#c06a2b]" data-id="element-41" data-mp="1zrk79zqpc8y7" />
                <span data-id="element-42" data-mp="24p2jq03xh6ay">Downtown Harrisonburg</span>
              </div>
            </div>

            <Button href="https://www.downtownharrisonburg.org/best-weekend-ever" target="_blank" rel="noopener noreferrer" variant="outline" className="w-full sm:w-auto" data-id="element-43" data-mp="171jz9s0wmfr4">
              About Best Weekend Ever
            </Button>
          </div>
        </div>
      </div>
    </section>;
}